import React from 'react';
import { Main, Price, Title } from './styles';

interface Props {
  title: string;
  price: string | number;
}
export default function ReferBox(props: Props) {
  return (
    <>
      <Main>
        <Title>{props.title}</Title>
        <Price>{props.price}</Price>
      </Main>
    </>
  );
}
